import jenniferMutch from "../../images/JenniferMutch.png";
import IntroductionBackground from "../../images/IntroductionBackground.png";
import { Link } from "react-router-dom";
export default function Introduction() {
  return (
    <div className="row introduction">
      <div className="container">
        {/* <img
          src={IntroductionBackground}
          alt=""
          className="IntroductionBackground"
        /> */}
        <div className="col s12 l6 white-text left leftSection">
          <h1 className="white-text" style={{ fontSize: "30px" }}>
            <b>Dr. Jennifer Mutch</b>
          </h1>
          <h5>Orthopedic Surgeon</h5>
          <span style={{ fontSize: "16px" }}>Specialized in: </span>
          <ul>

            <li>
              <a style={{ fontSize: "16px" }} href="">
                - Knee Replacement, Partial Knee Replacement, Hip Replacement,
                Shoulder Replacement
              </a>
            </li>
          </ul>
        </div>
        <div className="col s12 l4 rightSection">
          <img src={jenniferMutch} alt="" className="right introductionImage" />
        </div>
        {/* <div className="col s12">
          <a className="waves-effect waves-light btn-large white black-text btn-appointment">
                                        <Link to="/ContactUs" className="black-text">
                                         <i className="material-icons left">schedule</i>Contact Us

                        </Link>
          </a>

        </div> */}
      </div>
    </div>
  );
}
